export const en = {
    navigation: {
        menu: 'Menu',
    },
    date: {
        day: '0 days | 1 day | {count} days',
    },
    text: {
        in: 'in',
        destination: 'Destination',
        arrivalDeparture: 'Arrival- /Departure',
        duration: 'Duration',
        people: 'Person | People',
        budget: 'Budget',
        price: 'Price',
        transportType: 'Transport Type',
        recommendedTravelTime: 'Recommended In',
        discoverRoute: 'Discover route'
    },
    trip: {
        action: {
            detail: 'Tour planing',
        },
    },
    tour: {
        headline: 'A tour you might like:'
    },
};
